import React from 'react';
import './Ad.css';

export default class Ad extends React.Component {

    componentDidMount () {

        const script = document.createElement("script");

        script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        script.async = true;
        script.setAttribute("data-ad-client", "ca-pub-7317245021228731");
        document.head.appendChild(script);

        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    render () {

        return window.innerWidth >= 1024 ? (
            <ins className='adsbygoogle unit ba b--light-gray mb1 br2 bg-white near-black tl db overflow-hidden'
                 data-ad-format = "fluid"
                 data-ad-client='ca-pub-7317245021228731'
                 data-ad-slot='8098907406'
                 data-full-width-responsive="true"
            />
        ) : '';
    }
}